module.exports = __webpack_public_path__ + "static/media/wp6411971.7e9b27ce.jpg";